import { PRIMARY_MARKETS } from '@/constants/markets';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

export function getReadableCountry(
  safeCountry: PrimaryCountryISOElseGlobal,
  prop: 'label' | 'demonym' | 'mainIndex' = 'demonym'
): string {
  if (safeCountry in PRIMARY_MARKETS) {
    if (prop in PRIMARY_MARKETS[safeCountry]) {
      return PRIMARY_MARKETS[safeCountry][prop] as string; // we already null checked this TS ffs
    }
    // fall back to label
    if ('label' in PRIMARY_MARKETS[safeCountry]) {
      return PRIMARY_MARKETS[safeCountry].label;
    }
  }
  return 'Global';
}

export function isMarketSupported(market?: string) {
  if (!market) return false;
  return market.toLowerCase() in PRIMARY_MARKETS;
}

export const checkSupportedMarket = (market?: PrimaryCountryISOElseGlobal) => {
  if (typeof market === 'undefined') return;
  if (market === 'global' || isMarketSupported(market)) return market;
  return;
};
